import React from 'react';
import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    textBoxSpacing: {
        marginBottom: theme.spacing(1.5),
        [theme.breakpoints.down('sm')]: {
            marginBottom: theme.spacing(1),
        },

    },

}));



interface ContentSpacerProps {
    hide?: boolean;
}
export const ContentSpacer = (props: React.PropsWithChildren<ContentSpacerProps>) => {
    const classes = useStyles();

    if (props.hide) return null;

    return (

        <div className={classes.textBoxSpacing}>
            {props.children}
        </div>

    );
};

ContentSpacer.defaultProps = {
    hide: false,
};